import {NgModule, ModuleWithProviders } from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule } from '@angular/forms';
import {StopPropagationDirective } from './stop-propagation.directive';
import {AlertComponent } from './alert/alert.component';
import {AlertService} from './alert/alert.service';
import {SigninGeneralService} from './signinGeneral.service';
import {Injector} from '@angular/core';
import {setAppInjector} from './app-injector';
import {ShowHtmlPipe} from './show-html.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
  ],
  declarations: [
    StopPropagationDirective,
    AlertComponent,
    ShowHtmlPipe,
  ],
  providers: [SigninGeneralService],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    StopPropagationDirective,
    AlertComponent,
    ShowHtmlPipe
  ]
})
  export class SharedModule {
    constructor(injector: Injector) {
      setAppInjector(injector);
  }
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
        ngModule: SharedModule,
        providers: [AlertService]
        // providers: [ AlertService, SessionStorageService, PermissionsService, RulePopupService, SigninGeneralService ]
    };
}
}
